export default __webpack_public_path__ + "static/media/q-clock.6b0775f5.svg";